import { Building2, ChevronDown } from 'lucide-react';
import type { UserOrg } from '../lib/org-context';

interface OrgSelectorProps {
  orgs: UserOrg[];
  current: UserOrg | null;
  onSelect: (org: UserOrg) => void;
}

/** Sidebar org switcher. Always surfaces the active org scope — only hides
 * when the user has no orgs (Worker offline / unauthorized). */
export function OrgSelector({ orgs, current, onSelect }: OrgSelectorProps) {
  if (orgs.length === 0) return null;

  return (
    <label
      className="flex items-center gap-2 w-full px-2.5 py-2 rounded-md border text-sm cursor-pointer"
      style={{ borderColor: 'var(--border)', background: 'var(--accent-bg)', color: 'var(--ink)' }}
      title="Switch organization"
    >
      <Building2 className="w-4 h-4 flex-shrink-0" style={{ color: 'var(--accent)' }} />
      <select
        value={current?.orgId ?? ''}
        onChange={(e) => {
          const next = orgs.find((o) => o.orgId === e.target.value);
          if (next) onSelect(next);
        }}
        className="appearance-none pr-1 bg-transparent focus:outline-none cursor-pointer flex-1 min-w-0 truncate"
        aria-label="Switch organization"
      >
        {orgs.map((o) => (
          <option key={o.orgId} value={o.orgId}>
            {o.orgName}
          </option>
        ))}
      </select>
      <ChevronDown className="w-3.5 h-3.5 flex-shrink-0" style={{ color: 'var(--ink-secondary)' }} />
    </label>
  );
}
